'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _deepEqual = require('deep-equal');

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
	class: {
		type: 'string'
	},
	onChange: {
		type: 'function'
	},
	qty: {
		type: 'number'
	}
}; /** @jsx dom */


var defaultProps = {
	min: 1,
	max: false
};

var onClick = function onClick(qty, onChange) {
	return function () {
		return onChange(qty);
	};
};
var shouldUpdate = function shouldUpdate(_ref, nextProps) {
	var props = _ref.props;
	return !(0, _deepEqual2.default)(props, nextProps);
};

var render = function render(_ref2) {
	var props = _ref2.props;
	var onChange = props.onChange,
	    max = props.max,
	    min = props.min,
	    qty = props.qty;

	var isMax = max !== false && qty >= max;
	var isMin = min !== false && qty <= min;

	var subtractClasses = {
		'QtySelect-minus': true,
		'QtySelect-minus--disabled': isMin
	};

	var addClasses = {
		'QtySelect-plus': true,
		'QtySelect-plus--disabled': isMax
	};

	return (0, _magicVirtualElement2.default)(
		'div',
		{ 'class': ['QtySelect', props.class] },
		(0, _magicVirtualElement2.default)(
			'span',
			{ 'class': subtractClasses, onClick: !isMin && onClick(qty - 1, onChange) },
			(0, _magicVirtualElement2.default)(_icon2.default, { style: 'minus' })
		),
		(0, _magicVirtualElement2.default)(
			'span',
			{ 'class': 'QtySelect-qty' },
			qty
		),
		(0, _magicVirtualElement2.default)(
			'span',
			{ 'class': addClasses, onClick: !isMax && onClick(qty + 1, onChange) },
			(0, _magicVirtualElement2.default)(_icon2.default, { style: 'plus' })
		)
	);
};

exports.default = { defaultProps: defaultProps, propTypes: propTypes, render: render, shouldUpdate: shouldUpdate };